module.exports = __webpack_public_path__ + "img/eattake-vertical-colorida-svg.dac63622.svg";